import * as React from "react";
import Layout from "./Layout";
import { Box, Container, Link, Typography } from "@mui/material";
import Results from "./Results";

const MuzikantskaPage = () => {
    return (
        <Layout>
            <Container maxWidth={"md"}>
                <Typography component="h1" variant="h2">
                    Muzikantská stezka
                </Typography>
                <Typography variant={"h4"} component={"h2"} gutterBottom>
                    6. segment - říjen
                </Typography>
                <ul>
                    <li>
                        <Link href={"https://www.strava.com/segments/20928255"}>
                            Segment na webu STRAVA
                        </Link>
                    </li>
                </ul>
                <Typography gutterBottom>
                    Máme tu finále celého seriálu. ANO, je tu krátký - 1,25 km,
                    ale výživný výběh z Jeseníku na lázeňskou kolonádu (165m
                    výškových).
                </Typography>

                <Box
                    component={"ul"}
                    sx={{ marginTop: (theme) => theme.spacing(2) }}
                >
                    <li>
                        Start je situován na začátek nově opravené Tyršovy
                        ulice. Ihned za mostem přes řeku Staříč. Zde se zatáčí
                        doprava a běží po cestičce, která Vás dovede k domům a
                        ulici Na Úbočí. Nebojte, celá trasa je značená modrou
                        značkou. Pak už pořád nahoru krásným terénem.
                    </li>
                    <li>
                        Cíl je na začátku doběhu na kolonádě. Doporučuji ještě
                        vydržet se silami a uběhnout 7-10m po kolonádě směrem k
                        centru lázní.
                    </li>
                </Box>
                <Results segmentId={"3-5-20928255"} />
            </Container>
        </Layout>
    );
};

export default MuzikantskaPage;
